import { useContext } from 'react';
import { ThemeCtx } from './ThemeCtx';

export function useTheme() {
  const ctx = useContext(ThemeCtx);
  if (!ctx) throw new Error('useTheme must be used within an AppThemeProvider');
  return ctx;
}
